const Block = ({ title, children, id }) => (
  <div className="card" data-testid={`handoff-${id}`} style={{ padding: 28 }}>
    <div className="eyebrow">{title}</div>
    <div style={{ marginTop: 14 }}>{children}</div>
  </div>
);

const KV = ({ obj }) => (
  <dl style={{ margin: 0, display: "grid", gridTemplateColumns: "140px 1fr", rowGap: 10, columnGap: 16, fontSize: 13, lineHeight: 1.55 }}>
    {Object.entries(obj).map(([k, v]) => [<dt key={k + "k"} style={{ color: "var(--ink-40)", fontWeight: 600, textTransform: "capitalize" }}>{k.replace("_", " ")}</dt>, <dd key={k + "v"} style={{ margin: 0 }}>{v}</dd>])}
  </dl>
);

export default function HandoffDoc({ doc }) {
  if (!doc) return null;
  return (
    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20, marginTop: 40 }}>
      <div style={{ gridColumn: "1 / -1" }}>
        <Block title="Timing map" id="timing">
          <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 13 }}>
            <thead><tr style={{ textAlign: "left", color: "var(--ink-40)" }}>{["Time", "Clip", "Picture", "Overlay", "VO", "Sound"].map((h) => <th key={h} style={{ padding: "8px 10px", borderBottom: "1px solid var(--ink-12)", fontWeight: 600 }}>{h}</th>)}</tr></thead>
            <tbody>{doc.timing.map((r) => (
              <tr key={r.t} style={{ verticalAlign: "top" }}>
                <td className="serif" style={{ padding: "12px 10px", fontSize: 20, fontWeight: 600, whiteSpace: "nowrap", color: "var(--burgundy)" }}>{r.t}</td>
                <td style={{ padding: "12px 10px", fontWeight: 600, whiteSpace: "nowrap" }}>{r.clip}</td>
                <td style={{ padding: "12px 10px", lineHeight: 1.5 }}>{r.picture}</td>
                <td style={{ padding: "12px 10px", lineHeight: 1.5 }}>{r.overlay}</td>
                <td style={{ padding: "12px 10px", whiteSpace: "nowrap" }}>{r.vo}</td>
                <td style={{ padding: "12px 10px", lineHeight: 1.5 }}>{r.sound}</td>
              </tr>))}
            </tbody>
          </table>
        </Block>
      </div>
      <Block title="VO script" id="vo">
        <ol style={{ margin: 0, paddingLeft: 0, listStyle: "none", display: "flex", flexDirection: "column", gap: 14 }}>
          {doc.vo_script.map((v) => (
            <li key={v.n} style={{ display: "grid", gridTemplateColumns: "56px 1fr", gap: 12 }}>
              <span style={{ fontSize: 12, fontWeight: 700, color: "var(--ink-40)", paddingTop: 5 }}>{v.t}</span>
              <span className="serif" style={{ fontSize: 22, lineHeight: 1.3, fontStyle: "italic" }}>“{v.line}”</span>
            </li>))}
        </ol>
        <div style={{ marginTop: 24, paddingTop: 20, borderTop: "1px solid var(--ink-06)" }}><KV obj={doc.vo_direction} /></div>
      </Block>
      <Block title="Sound-design cue list" id="sound">
        <ul style={{ margin: 0, padding: 0, listStyle: "none", display: "flex", flexDirection: "column", gap: 10, fontSize: 13, lineHeight: 1.5 }}>
          {doc.sound_cues.map((c) => <li key={c.t} style={{ display: "grid", gridTemplateColumns: "90px 1fr", gap: 12 }}><b style={{ color: "var(--burgundy)" }}>{c.t}</b><span>{c.cue}</span></li>)}
        </ul>
      </Block>
      <Block title="Color grade · LUT direction" id="grade"><KV obj={doc.grade} /></Block>
      <Block title="Compositing notes" id="compositing">
        <ul style={{ margin: 0, paddingLeft: 18, fontSize: 13, lineHeight: 1.6, display: "flex", flexDirection: "column", gap: 8 }}>{doc.compositing.map((c, i) => <li key={i}>{c}</li>)}</ul>
      </Block>
      <Block title="On-screen text placement" id="text">
        {doc.text_overlays.map((t) => (
          <div key={t.t} style={{ display: "grid", gridTemplateColumns: "100px 1fr", gap: 12, padding: "10px 0", borderBottom: "1px solid var(--ink-06)", fontSize: 13 }}>
            <b style={{ color: "var(--burgundy)" }}>{t.t}</b>
            <div><div className="serif" style={{ fontSize: 22 }}>{t.text}</div><div style={{ color: "var(--ink-60)", marginTop: 2 }}>{t.style}</div></div>
          </div>))}
      </Block>
      <Block title="Delivery spec" id="spec"><KV obj={doc.spec} /></Block>
    </div>
  );
}
